module.exports = __webpack_public_path__ + "img/schm.5d0e2782.png";